// extracted by mini-css-extract-plugin
module.exports = {"AddressInputs":"AddressInputs_AddressInputs__Gi0lp","Split":"AddressInputs_Split__Z2m2X"};